export const movies = [
  {
    id: "mv-001",
    title: "长河落日",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["历史", "剧情", "战争"],
    rating: 9.2,
    director: "陈望川",
    actors: ["林砚秋", "周予安", "高远"],
    duration: "168分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20key%20art%20of%20a%20lone%20warrior%20standing%20on%20a%20vast%20golden%20river%20plain%20at%20sunset%2C%20dramatic%20amber%20and%20deep%20teal%20color%20grading%2C%20atmospheric%20haze%2C%20painterly%20historical%20epic%20illustration%2C%20soft%20light%20rays%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20a%20vast%20golden%20river%20plain%20at%20dusk%2C%20distant%20mountains%20silhouette%2C%20warm%20amber%20sky%20with%20dramatic%20clouds%2C%20moody%20atmospheric%20historical%20war%20epic%20mood%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=movie-back-001&orientation=landscape",
    summary:
      "以一场决定命运的大决战为背景，讲述几位普通士兵在时代洪流中的抉择与守望。影片以恢弘的长镜头与细腻的人物刻画，勾勒出山河与人心的双重壮阔，是一部兼具史诗气质与人性温度的国产历史剧情片。",
    popularity: 98,
  },
  {
    id: "mv-002",
    title: "风起长安",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "剧情", "悬疑"],
    rating: 8.8,
    director: "沈墨白",
    actors: ["苏澈", "江晚吟", "柳承宇"],
    duration: "142分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20key%20art%20of%20an%20ancient%20Chinese%20city%20under%20drifting%20mist%2C%20a%20solitary%20figure%20in%20a%20long%20dark%20robe%2C%20deep%20indigo%20and%20muted%20gold%20color%20grading%2C%20soft%20haze%2C%20painterly%20oriental%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20panorama%20of%20a%20misty%20ancient%20Chinese%20imperial%20city%20with%20tiered%20rooftops%20and%20lanterns%2C%20deep%20indigo%20twilight%2C%20drifting%20fog%2C%20moody%20oriental%20mystery%20atmosphere%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=movie-back-002&orientation=landscape",
    summary:
      "长安城连发离奇命案，一位被贬的年轻捕快与一名神秘女子联手追查真相。层层迷雾之下，是盘根错节的权谋与人心。影片以考究的服化道与凌厉的节奏，重现东方古都的暗涌风云。",
    popularity: 94,
  },
  {
    id: "mv-003",
    title: "无声边境",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["谍战", "悬疑", "剧情"],
    rating: 8.6,
    director: "许冬临",
    actors: ["顾清野", "孟之遥", "韩肆"],
    duration: "136分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20spy%20thriller%20movie%20poster%20key%20art%20of%20a%20silhouetted%20figure%20in%20a%20long%20coat%20walking%20through%20a%20rainy%20neon-lit%20old%20street%20at%20night%2C%20cold%20blue%20and%20steel%20grey%20tones%2C%20moody%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-003&orientation=portrait",
    summary:
      "边境小城的平静被一份加密电文打破，潜伏多年的情报员被迫在身份暴露的边缘走钢丝。信任与背叛之间，一次沉默的抉择将改变所有人的命运。",
    popularity: 90,
  },
  {
    id: "mv-004",
    title: "星海征途",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    rating: 9.0,
    director: "罗砚舟",
    actors: ["秦亦风", "段清岚", "白岩"],
    duration: "155分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20key%20art%20of%20a%20lone%20astronaut%20before%20a%20vast%20glowing%20nebula%20and%20ringed%20planet%2C%20deep%20indigo%20and%20warm%20amber%20accents%2C%20luminous%20haze%2C%20painterly%20space%20opera%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-004&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20landscape%20with%20a%20giant%20ringed%20planet%20and%20swirling%20nebula%20clouds%2C%20deep%20indigo%20and%20violet-blue%20cosmos%20with%20warm%20amber%20star%20glow%2C%20luminous%20atmospheric%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=movie-back-004&orientation=landscape",
    summary:
      "人类首支深空远航舰队踏上寻找新家园的征途，然而漫长的寂静航行中，真正的敌人或许来自船内。影片以震撼的视觉奇观与扎实的科学设定，探索孤独、信任与文明的边界。",
    popularity: 96,
  },
  {
    id: "mv-005",
    title: "都市夜航",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "剧情", "爱情"],
    rating: 8.3,
    director: "温以宁",
    actors: ["夏知遥", "陆行舟", "温和"],
    duration: "118分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20romance%20movie%20poster%20key%20art%20of%20a%20couple%20standing%20apart%20on%20a%20rain-slicked%20city%20street%20at%20night%20with%20warm%20amber%20window%20glow%2C%20teal%20and%20gold%20color%20grading%2C%20soft%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-005&orientation=portrait",
    summary:
      "在一座永不打烊的城市里，两个失眠的陌生人因一班深夜公交相遇。他们分享彼此的秘密，也重新学会与生活和解。一部温柔而克制的都市爱情小品。",
    popularity: 84,
  },
  {
    id: "mv-006",
    title: "迷雾追凶",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "惊悚"],
    rating: 8.7,
    director: "裴远山",
    actors: ["严冬", "侯雨桐", "纪川"],
    duration: "128分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20key%20art%20of%20a%20foggy%20forest%20road%20with%20a%20single%20car%20headlight%20beam%2C%20cold%20grey-blue%20moody%20tones%20with%20a%20dull%20orange%20glow%2C%20dense%20mist%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-006&orientation=portrait",
    summary:
      "一场大雾笼罩的连环失踪案，让一名固执的老刑警与一位年轻法医被迫合作。当真相逐渐浮出水面，他们发现最深的迷雾藏在人心之中。",
    popularity: 88,
  },
  {
    id: "mv-007",
    title: "胡同里的夏天",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["家庭", "温情", "剧情"],
    rating: 8.9,
    director: "宋念之",
    actors: ["周奶奶", "小满", "赵叔"],
    duration: "106分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20family%20film%20poster%20key%20art%20of%20a%20sunlit%20old%20Chinese%20hutong%20alley%20with%20green%20vines%20and%20bicycles%2C%20golden%20afternoon%20light%2C%20cozy%20nostalgic%20summer%20mood%2C%20soft%20color%20grading%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-007&orientation=portrait",
    summary:
      "一个在外打拼失败的年轻人回到老胡同，与固执的奶奶度过一个夏天。院墙内的烟火日常，慢慢治愈了彼此的伤痕。一部让人会心一笑又鼻尖发酸的温情之作。",
    popularity: 82,
  },
  {
    id: "mv-008",
    title: "山海之约",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["爱情", "文艺", "剧情"],
    rating: 8.1,
    director: "梁以安",
    actors: ["程未晚", "沈屿", "何书宁"],
    duration: "112分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20romance%20film%20poster%20key%20art%20of%20two%20figures%20walking%20along%20a%20misty%20coastal%20cliff%20at%20dawn%2C%20muted%20teal%20sea%20and%20soft%20peach%20sky%2C%20gentle%20haze%2C%20minimal%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-008&orientation=portrait",
    summary:
      "摄影记者与海洋研究员在海边小镇重逢，一段被时光搁置的往事重新被翻开。影片以克制的镜头语言，讲述关于等待、告别与和解的故事。",
    popularity: 79,
  },
  {
    id: "mv-009",
    title: "破晓行动",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["动作", "犯罪", "剧情"],
    rating: 8.4,
    director: "铁云峰",
    actors: ["龙锐", "许猛", "艾琳"],
    duration: "124分钟",
    poster:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20poster%20key%20art%20of%20a%20lone%20figure%20silhouetted%20against%20an%20exploding%20orange%20skyline%20at%20dawn%2C%20dramatic%20amber%20and%20deep%20navy%20tones%2C%20smoke%20and%20sparks%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-009&orientation=portrait",
    summary:
      "一支特勤小队在执行黎明突袭任务时遭遇伏击，队长必须在四十八小时内找出内鬼并完成任务。紧张刺激的枪战与拳拳到肉的动作设计，热血十足。",
    popularity: 86,
  },
  {
    id: "mv-010",
    title: "时间的褶皱",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "剧情", "悬疑"],
    rating: 8.8,
    director: "程默",
    actors: ["方衍", "苏晚", "林澈"],
    duration: "138分钟",
    poster:
      "https://readdy.ai/api/search-image?query=Surreal%20sci-fi%20movie%20poster%20key%20art%20of%20a%20fractured%20clock%20and%20a%20person%20dissolving%20into%20light%20particles%2C%20deep%20blue%20and%20warm%20gold%20grading%2C%20ethereal%20glow%2C%20painterly%20conceptual%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=movie-poster-010&orientation=portrait",
    summary:
      "一位物理学家发现女儿的记忆被困在时间的褶皱里，为了把她带回现实，他必须一次次穿越同一个黄昏。一部烧脑又催泪的软科幻家庭片。",
    popularity: 92,
  },
  {
    id: "tv-001",
    title: "京华烟云录",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "剧情", "家庭"],
    rating: 8.9,
    director: "叶知秋",
    actors: ["顾锦书", "沈砚", "陆知微"],
    duration: "全46集",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20key%20art%20of%20an%20elegant%20lady%20in%20a%20traditional%20embroidered%20gown%20before%20a%20grand%20old%20mansion%2C%20muted%20jade%20and%20gold%20color%20grading%2C%20soft%20haze%2C%20painterly%20oriental%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20panorama%20of%20a%20grand%20traditional%20Chinese%20mansion%20courtyard%20at%20dusk%20with%20lanterns%20and%20blossom%20trees%2C%20muted%20jade%20green%20and%20warm%20gold%2C%20soft%20atmospheric%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=tv-back-001&orientation=landscape",
    summary:
      "以百年家族兴衰为轴，讲述三姐妹在时代变迁中的爱恨与抉择。剧集以精致的置景、考究的台词和丰满的群像，被誉为近年最具质感的年代家族史诗。",
    popularity: 97,
  },
  {
    id: "tv-002",
    title: "迷雾档案",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "刑侦", "剧情"],
    rating: 9.1,
    director: "穆远",
    actors: ["程昱", "岑宁", "赵启明"],
    duration: "全32集",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20poster%20key%20art%20of%20a%20detective%20examining%20a%20corkboard%20of%20photos%20in%20a%20dim%20office%2C%20cold%20grey-blue%20tones%20with%20a%20dull%20amber%20desk%20lamp%2C%20moody%20shadow%20play%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-002&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20moody%20interior%20of%20a%20dim%20detective%20office%20at%20night%20with%20venetian%20blind%20shadows%20and%20a%20warm%20desk%20lamp%2C%20cold%20grey-blue%20atmosphere%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=tv-back-002&orientation=landscape",
    summary:
      "一支专门重启悬案的小队，用现代刑侦技术揭开一桩桩尘封多年的谜题。每一集都是一次智力博弈，每一次真相都令人唏嘘。年度口碑犯罪悬疑佳作。",
    popularity: 95,
  },
  {
    id: "tv-003",
    title: "都市守望者",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["都市", "职场", "剧情"],
    rating: 8.5,
    director: "许安安",
    actors: ["林越", "苏念", "陈默"],
    duration: "全40集",
    poster:
      "https://readdy.ai/api/search-image?query=Contemporary%20urban%20workplace%20drama%20poster%20key%20art%20of%20a%20confident%20young%20professional%20against%20a%20glass%20skyscraper%20skyline%20at%20blue%20hour%2C%20cool%20navy%20and%20warm%20amber%20accents%2C%20subtle%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-003&orientation=portrait",
    summary:
      "三位来自不同背景的年轻人在同一家公司相遇，在竞争与协作中寻找自己的位置。剧集真实描摹当代都市职场的理想与现实，引发无数打工人共鸣。",
    popularity: 87,
  },
  {
    id: "tv-004",
    title: "大江向东",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["年代", "剧情", "励志"],
    rating: 9.0,
    director: "何向东",
    actors: ["雷大川", "赵红梅", "孙建国"],
    duration: "全48集",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20key%20art%20of%20a%20rural%20family%20walking%20along%20a%20wide%20river%20at%20sunset%20in%20the%201980s%2C%20warm%20sepia%20and%20muted%20teal%20grading%2C%20nostalgic%20atmospheric%20haze%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-004&orientation=portrait",
    summary:
      "从改革开放到新时代，三代人在一条大河畔书写属于普通人的奋斗史。剧集以质朴的底色与滚烫的理想，展现时代浪潮下的家国记忆。",
    popularity: 89,
  },
  {
    id: "tv-005",
    title: "厨房里的秘密",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "情感", "美食"],
    rating: 8.2,
    director: "温柔",
    actors: ["姜小厨", "陆明", "白露"],
    duration: "全28集",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20foodie%20drama%20poster%20key%20art%20of%20a%20cozy%20small%20restaurant%20kitchen%20with%20steaming%20dishes%20and%20hanging%20warm%20lights%2C%20golden%20amber%20and%20soft%20teal%20grading%2C%20inviting%20atmosphere%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-005&orientation=portrait",
    summary:
      "一间藏在巷子深处的小餐馆，成了都市人安放秘密与心事的地方。每一道菜背后，都有一个关于思念、原谅与成长的故事。治愈系美食情感剧。",
    popularity: 81,
  },
  {
    id: "tv-006",
    title: "侠影行",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["武侠", "古装", "动作"],
    rating: 8.6,
    director: "风清越",
    actors: ["谢云舟", "慕容雪", "楚河"],
    duration: "全36集",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%20key%20art%20of%20a%20swordsman%20standing%20on%20a%20bamboo%20forest%20peak%20in%20flowing%20robes%2C%20deep%20jade%20green%20and%20misty%20white%2C%20drifting%20clouds%2C%20painterly%20oriental%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-006&orientation=portrait",
    summary:
      "动荡江湖中，一名孤儿因一场意外习得绝世剑法，踏上寻找身世与正义的旅途。快意恩仇之间，叩问何谓真正的侠。一部画面与武打都在线的古装武侠剧。",
    popularity: 85,
  },
  {
    id: "tv-007",
    title: "未来纪元",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "剧情"],
    rating: 8.7,
    director: "尹川",
    actors: ["萧决", "黎星", "云泽"],
    duration: "全30集",
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20series%20poster%20key%20art%20of%20a%20neon%20mega%20city%20skyline%20reflected%20in%20rain%2C%20deep%20indigo%20and%20warm%20amber%20neon%2C%20dense%20atmospheric%20haze%2C%20painterly%20cyberpunk%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-007&orientation=portrait",
    summary:
      "在人工智能深度介入生活的未来都市，一起离奇失控事件牵出庞大阴谋。一名数据侦探在虚拟与现实的夹缝中追寻真相。设定硬核、悬念迭起的华语科幻剧。",
    popularity: 93,
  },
  {
    id: "tv-008",
    title: "回廊里的回声",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "家庭", "剧情"],
    rating: 8.8,
    director: "缪知远",
    actors: ["钟情", "顾长明", "林晚"],
    duration: "全24集",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20mystery%20drama%20poster%20key%20art%20of%20a%20long%20empty%20hotel%20corridor%20with%20flickering%20warm%20lamps%20and%20rain%20on%20windows%2C%20cold%20teal%20and%20dull%20amber%20tones%2C%20quiet%20unease%2C%20painterly%20illustration%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-poster-008&orientation=portrait",
    summary:
      "一栋老宅里，不同年代的住客在同一个回廊留下各自的遗憾。当尘封的旧信被重新打开，一段跨越时空的家族秘密缓缓浮现。节奏沉稳、氛围绝佳的悬疑家庭剧。",
    popularity: 83,
  },
];